var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vast-service-order-now-modal-header"},[_c('div',[_vm._t("default")],2),_c('button',{staticClass:"vast-service-order-now-modal-header__close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('IconClose',{attrs:{"width":"23"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }